import { styled, keyframes } from "@mui/material/styles";
import { Theme } from "../Theme";

const rotation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const Backdrop = styled("div")(({ theme }) =>
  theme.unstable_sx({
    position: "fixed",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 900,
    background: theme.tokens.colors.gray[2],
    visibility: "visible",

    "& .spin": {
      display: "flex",
      width: "100%",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

export const Spinner = styled("span")(
  ({ size, theme, center }: { size: string; theme: Theme; center?: boolean }) => {
    let style: React.CSSProperties = {
      width: size,
      height: size,
      border: `4px solid ${theme.tokens.colors.gray["7"]}`,
      borderBottomColor: "transparent",
      borderRadius: "50%",
      display: "inline-block",
      boxSizing: "border-box",
      animation: `${rotation} 1s linear infinite`,
    };
    if (center) {
      style = {
        ...style,
        position: "absolute",
        left: "50%",
        top: "50%",
        marginLeft: `-${size}`,
      };
    }
    return theme.unstable_sx(style);
  }
);
